import { Component } from '@angular/core';
import {HeroLaboratorioComponent} from "../hero-laboratorio/hero-laboratorio.component";
import {InfoLaboratorioComponent} from "../info-laboratorio/info-laboratorio.component";

@Component({
  selector: 'app-all-laboratorio',
  standalone: true,
  imports: [
    HeroLaboratorioComponent,
    InfoLaboratorioComponent
  ],
  templateUrl: './all-laboratorio.component.html',
  styleUrl: './all-laboratorio.component.css'
})
export class AllLaboratorioComponent {

}
